import React from "react";
import { Helmet } from "react-helmet";

import LandingSegment from "./home-segments/LandingSegment.js";
import BackStorySegment from "./home-segments/BackStorySegment.js";
import { Container } from "react-bootstrap";

function Home(props) {
  return (
    <>
      <Helmet>
        <title>Matamando Kalilani - Full Stack Cloud Developer</title>
        <meta
          name="description"
          content="Hi, my name is Matamando Kalilani, and I am a Full Stack Developer - (Software Engineer) based in, Lilongwe, Malawi."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://mata.codes/" />
      </Helmet>{" "}
      <div className="whiteSegment full-landing-segment">
        <Container style={{ height: "100%" }}>
          <LandingSegment />
        </Container>
      </div>
      <div className="colorSegment">
        <Container style={{ height: "100%" }}>
          <BackStorySegment />
        </Container>
      </div>
      {/* <div className="whiteSegment">
        <Container fluid="xl" style={{ height: "100%" }}>
          <BackStorySegment />
        </Container>
      </div> */}
    </>
  );
}

export default Home;
